import React from 'react';
import { SimpleBlock } from 'ui-builder';

import styles from './TextBadge.module.scss';

export enum TextBadgeStyle {
  DRAFT = 'draft',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

export function TextBadge(props: {
  text: string,
  style?: TextBadgeStyle,
}) {


  const style = props.style || TextBadgeStyle.ACTIVE;

  return (
    <SimpleBlock className={`${styles.badge} ${styles[style.toLowerCase()]}`}>
      {props.text}
    </SimpleBlock>
  );
}
